import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ShellService } from '@mynexus/mfe-core';
import { MessageService } from 'primeng/api';

@NgModule({ declarations: [],
    exports: [CommonModule], imports: [CommonModule], providers: [ShellService, MessageService, provideHttpClient(withInterceptorsFromDi())] })
export class CoreModule {}
